import React from 'react';

import ErrorIcon from '@mui/icons-material/ErrorOutline';

import ArrowTooltipCss from '../../ArrowTooltipCss';

export default ({ tooltipText }) => (
  <ArrowTooltipCss text={tooltipText || 'Mandatory field'}>
    <ErrorIcon
      style={{
        color: '#DD5900',
        fontSize: '18px',
        marginLeft: '5px',
      }}
    />
  </ArrowTooltipCss>
);
